import { gamification } from "@circle-react/helpers/urlHelpers/internalApi/gamification";

import { accessRegistry } from "./accessRegistry";
import { accountAuthentication } from "./accountAuthentication";
import { accountPaymentProcessors } from "./accountPaymentProcessors";
import { AccountSubscriptions } from "./accountSubscriptions";
import { admin } from "./admin";
import { aiWorkflowsBillingHistory } from "./aiWorkflowsBillingHistory";
import { analytics } from "./analytics";
import { apiAnalytics } from "./apiAnalytics";
import { apiTokens } from "./apiTokens";
import { asyncTasks } from "./asyncTasks";
import { authProviders } from "./authProviders";
import { billingDetails } from "./billingDetails";
import { blockedMembers } from "./blockedMembers";
import { bookmarks } from "./bookmarks";
import { brandedAppsBuilderUI } from "./brandedAppsBuilderUI";
import { broadcasts } from "./broadcasts";
import { cancellationSurvey } from "./cancellationSurvey";
import { chatPreferences } from "./chatPreferences";
import { chatRoomMessages } from "./chatRoomMessages";
import { chatRoomParticipants } from "./chatRoomParticipants";
import { chatRooms } from "./chatRooms";
import { chatSpaces } from "./chatSpaces";
import { chatThreads } from "./chatThreads";
import { circleAiArtefacts } from "./circleAiArtefacts";
import { circleAiAvatarSetupConversation } from "./circleAiAvatarSetupConversation";
import { circleAiBotConversations } from "./circleAiBotConversations";
import { circleAiBots } from "./circleAiBots";
import { circleAiConversations } from "./circleAiConversations";
import { circleAiDailyBriefs } from "./circleAiDailyBriefs";
import { circleAiOfferHumanSupport } from "./circleAiOfferHumanSupport";
import { circleAiProjects } from "./circleAiProjects";
import { circleAiSkills } from "./circleAiSkills";
import { comments } from "./comments";
import { communities } from "./communities";
import { communityAiAgentProfile } from "./communityAiAgentProfile";
import { communityBot } from "./communityBot";
import { communityInbox } from "./communityInbox";
import { communityLead } from "./communityLead";
import { communityMember } from "./communityMember";
import { communityMemberBulkInvitations } from "./communityMemberBulkInvitations";
import { communityMemberCharge } from "./communityMemberCharge";
import { communityMemberPaymentMethod } from "./communityMemberPaymentMethod";
import { communityMemberPaymentProcessor } from "./communityMemberPaymentProcessor";
import { communityMembers } from "./communityMembers";
import { communityMemberSubscription } from "./communityMemberSubscription";
import { communityMemberSubscriptionPriceChanges } from "./communityMemberSubscriptionPriceChanges";
import { communityPaymentMethod } from "./communityPaymentMethod";
import { communityPlanAddons } from "./communityPlanAddons";
import { communityReviews } from "./communityReviews";
import { connectSettings } from "./connectSettings";
import { contactMarketingEmailPreferences } from "./contactMarketingEmailPreferences";
import { contactNewsletterListContacts } from "./contactNewsletterListContacts";
import { contacts } from "./contacts";
import { conversionTracking } from "./conversionTracking";
import { copilot } from "./copilot";
import { corsAllowedOrigins } from "./corsAllowedOrigins";
import { courses } from "./courses";
import { courseTopics } from "./courseTopics";
import { credits } from "./credits";
import { currentContact } from "./currentContact";
import { customDomain } from "./customDomain";
import { emailHub } from "./emailHub";
import { emailHubContactsUsage } from "./emailHubContactsUsage";
import { emailHubStatus } from "./emailHubStatus";
import { emailHubSubscription } from "./emailHubSubscription";
import { emailValidations } from "./emailValidations";
import { embeds } from "./embeds";
import { entityPreviews } from "./entityPreviews";
import { eventAttendees } from "./eventAttendees";
import { eventLiveStreams } from "./eventLiveStreams";
import { events } from "./events";
import { flaggedContent } from "./flaggedContent";
import { forms } from "./forms";
import { homePagePosts } from "./homePagePosts";
import { imagePosts } from "./imagePosts";
import { importContacts } from "./importContacts";
import { integrations } from "./integrations";
import { invitationLinks } from "./invitationLinks";
import { landingPageSettings } from "./landingPageSettings";
import { layoutPartials } from "./layoutPartials";
import { liveStreams } from "./liveStreams";
import { manageMembers } from "./manageMembers";
import { marketingEmailAddressSettings } from "./marketingEmailAddressSettings";
import { marketingEmailPreferences } from "./marketingEmailPreferences";
import { marketingEmailTemplates } from "./marketingEmailTemplates";
import { masquerading } from "./masquerading";
import { mediaChapterGenerations } from "./mediaChapterGenerations";
import { mediaSettings } from "./mediaSettings";
import { mediaTranscodings } from "./mediaTranscodings";
import { mediaTranscripts } from "./mediaTranscripts";
import { memberActivityScore } from "./memberActivityScore";
import { memberChecklist } from "./memberChecklist";
import { memberTags } from "./memberTags";
import { moderationSettings } from "./moderationSettings";
import { newsletterAudienceListContacts } from "./newsletterAudienceListContacts";
import { newsletterAudienceLists } from "./newsletterAudienceLists";
import { newsletterOverview } from "./newsletterOverview";
import { newsletterPosts } from "./newsletterPosts";
import { newsletters } from "./newsletters";
import { nextPlanWithFeature } from "./nextPlanWithFeature";
import { notificationPreferences } from "./notificationPreferences";
import { notifications } from "./notifications";
import { oneSchemaConfiguration } from "./oneSchemaConfiguration";
import { partnerProgram } from "./partnerProgram";
import { paywallCoupons } from "./paywallCoupons";
import { paywallGroup } from "./paywallGroup";
import { paywalls } from "./paywalls";
import { paywallCheckout } from "./paywalls/checkout";
import { paywallsAffiliatesSettings } from "./paywallsAffiliatesSettings";
import { pinnedChatRoom } from "./pinnedChatRoom";
import { planFeatureFlags } from "./planFeatureFlags";
import { plans } from "./plans";
import { planTrials } from "./planTrials";
import { polls } from "./polls";
import { postDetails } from "./postDetails";
import { postFollowers } from "./postFollowers";
import { posts } from "./posts";
import { priorityInbox } from "./priorityInbox";
import { profile } from "./profile";
import { profileFields } from "./profileFields";
import { punditUser } from "./punditUser";
import { pushNotifications } from "./pushNotifications";
import { quizAttempts } from "./quizAttempts";
import { reactions } from "./reactions";
import { recurringEvents } from "./recurringEvents";
import { richTextFields } from "./richTextFields";
import { scheduledEmails } from "./scheduledEmails";
import { scheduleDowngrades } from "./scheduleDowngrades";
import { search, searchV2 } from "./search";
import { segments } from "./segments";
import { settings } from "./settings";
import { sidebarNotifications } from "./sidebarNotifications";
import { site } from "./site";
import { spaceGroups } from "./spaceGroups";
import { spaceMembers } from "./spaceMembers";
import { spaces } from "./spaces";
import { storageUsage } from "./storageUsage";
import { submissions } from "./submissions";
import { supportedCurrencies } from "./supportedCurrencies";
import { systemMarketingEmailTemplates } from "./systemMarketingEmailTemplates";
import { topics } from "./topics";
import { unifiedInboxSupport } from "./unifiedInboxSupport";
import { upcomingEvents } from "./upcomingEvents";
import { voiceMessages } from "./voiceMessages";
import { workflowsUpcomingEvents } from "./workflowsUpcomingEvents";

export const internalApi = {
  admin,
  aiWorkflowsBillingHistory,
  analytics,
  asyncTasks,
  apiTokens,
  AccountSubscriptions,
  bookmarks,
  chatRoomMessages,
  chatRoomParticipants,
  chatRooms,
  chatSpaces,
  chatPreferences,
  circleAiArtefacts,
  circleAiAvatarSetupConversation,
  circleAiBotConversations,
  circleAiBots,
  circleAiConversations,
  circleAiDailyBriefs,
  circleAiOfferHumanSupport,
  circleAiProjects,
  circleAiSkills,
  comments,
  communities,
  communityAiAgentProfile,
  communityLead,
  contactMarketingEmailPreferences,
  contactNewsletterListContacts,
  communityMember,
  communityMemberCharge,
  communityMemberPaymentMethod,
  communityPaymentMethod,
  communityMemberPaymentProcessor,
  communityMembers,
  communityMemberSubscription,
  communityMemberSubscriptionPriceChanges,
  communityPlanAddons,
  communityReviews,
  connectSettings,
  customDomain,
  accountAuthentication,
  authProviders,
  billingDetails,
  courses,
  quizAttempts,
  embeds,
  entityPreviews,
  eventAttendees,
  eventLiveStreams,
  events,
  flaggedContent,
  forms,
  unifiedInboxSupport,
  copilot,
  credits,
  gamification,
  homePagePosts,
  imagePosts,
  invitationLinks,
  integrations,
  layoutPartials,
  liveStreams,
  manageMembers,
  conversionTracking,
  emailHubStatus,
  emailHub,
  emailHubContactsUsage,
  memberChecklist,
  memberTags,
  moderationSettings,
  newsletterAudienceListContacts,
  newsletterAudienceLists,
  newsletterOverview,
  newsletterPosts,
  newsletters,
  notificationPreferences,
  notifications,
  paywallCheckout,
  paywallCoupons,
  paywallGroup,
  paywalls,
  paywallsAffiliatesSettings,
  planFeatureFlags,
  planTrials,
  polls,
  postDetails,
  postFollowers,
  posts,
  priorityInbox,
  profile,
  contacts,
  currentContact,
  profileFields,
  punditUser,
  reactions,
  recurringEvents,
  richTextFields,
  search,
  searchV2,
  segments,
  settings,
  sidebarNotifications,
  site,
  spaceGroups,
  spaceMembers,
  spaces,
  submissions,
  supportedCurrencies,
  upcomingEvents,
  voiceMessages,
  workflowsUpcomingEvents,
  chatThreads,
  plans,
  scheduleDowngrades,
  emailHubSubscription,
  memberActivityScore,
  mediaChapterGenerations,
  mediaSettings,
  mediaTranscodings,
  mediaTranscripts,
  accountPaymentProcessors,
  landingPageSettings,
  masquerading,
  topics,
  courseTopics,
  communityMemberBulkInvitations,
  importContacts,
  scheduledEmails,
  broadcasts,
  pushNotifications,
  marketingEmailPreferences,
  marketingEmailAddressSettings,
  pinnedChatRoom,
  corsAllowedOrigins,
  apiAnalytics,
  communityInbox,
  communityBot,
  accessRegistry,
  nextPlanWithFeature,
  brandedAppsBuilderUI,
  oneSchemaConfiguration,
  partnerProgram,
  emailValidations,
  marketingEmailTemplates,
  systemMarketingEmailTemplates,
  blockedMembers,
  cancellationSurvey,
  storageUsage,
};
